import { Alert, AlertTitle, Box } from "@mui/material";
import React from "react";

interface Props {
  children: React.ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * Keeps a render error inside the Insights tab from blanking the whole admin,
 * and shows the error on screen so it can be read and fixed (rather than a blank
 * page). Reset per sub-tab via a `key` on the boundary.
 */
class InsightsErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render(): React.ReactNode {
    const { error } = this.state;
    if (error) {
      return (
        <Alert severity="error" sx={{ my: 2 }}>
          <AlertTitle>This Insights view hit an error</AlertTitle>
          <Box sx={{ fontWeight: 600, mb: 1 }}>{error.message}</Box>
          <Box
            component="pre"
            sx={{
              fontSize: 11,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 260,
              overflow: "auto",
              opacity: 0.75,
              m: 0,
            }}
          >
            {error.stack}
          </Box>
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default InsightsErrorBoundary;
